module.exports = __webpack_public_path__ + "img/sekur.9d9546ac.png";